module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER TWO")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("G"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OLDILOCKS")])])])]), _vm._v(" was finally going to make her move.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean could sense it. Something in the way she lifted her glass to her mouth, in the way she suddenly seemed to draw herself up, gave her away. He wanted to applaud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("About time, babe")])]), _vm._v(", he felt like saying. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("What took you so long?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Of course, he didn’t. Why give the game away now? He’d have bet a thousand bucks she had no idea he’d been watching her, no idea he was even aware of her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d noticed her as soon as he’d entered the casino. Or not entered it, which, he supposed, was a better way of putting it. He’d learned, long ago, that it was better to take his time, scope a place out, get the feel of things instead of walking right into a situation. So he’d been taking his time, standing in the arched entry between the foyer and the high-stakes gaming room, sipping Jack Daniel’s on the rocks as he watched.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Watched the tables. The players. The dealers. In a casino as in life, it paid to watch and wait.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That was when he’d noticed the blonde.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was tall, with a great body and legs that went on forever. Her face might have inspired Botticelli and just the sight of that lion’s mane of sun-streaked, silky-looking hair made him want to run his fingers through it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean sipped his bourbon.")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Oh, yeah. He’d noticed her, all right.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was checking things out, too. At least, that was what he’d thought. After a while, he realized he had it wrong.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What she was checking out was him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was careful about it. Nothing clumsy or overt. She’d chosen her spot well. The lighting in the little alcove where she stood was dim, probably in deliberate contrast to the bright lights in the gaming area.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But Sean had long ago learned that the devil was in the details. The success of his game depended on it. He saw everything, and saw it without making people aware he was looking. One seemingly casual glance and he could figure out how Lady Luck was treating players just by taking in the expressions on their faces, or even the way they handled their cards.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Besides, a man would have to be blind not to have seen the blonde. She was spectacular.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And she was gearing up for something. Something that involved him. The only question was, what?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d thought about walking up to her, looking into those green eyes and saying, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hello, sugar. Why are you watching me?")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It wasn’t an opening line to use on a woman if she was about to come on to you, but instinct told him the blonde didn’t have girl-meets-boy on her mind. No use pretending that wasn’t unusual, Sean thought without a trace of ego. He was as lucky with women as he was with cards. That was just the way it was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So, what was happening? Goldilocks was getting ready for something and it was making her nervous. He’d seen her hand tremble once or twice when she raised her champagne glass to her lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Curiosity had almost gotten the better of him when she began to move.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean narrowed his eyes as she stepped from the alcove and started toward him. Yes, the face was beautiful. Definitely Botticelli. But the body reminded him of a classical Greek sculpture. High, firm breasts. Slender waist. Those legs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And a walk that made the most of all her assets.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Spine straight. Shoulders back. Arms swinging as she strutted toward him, crossing one long leg over the other so that she moved more like a tigress than a woman. It was a model’s walk. He’d dated a German supermodel last year; Ursula had done The Walk for him in his living room, wearing nothing but a sultry pout and a lace teddy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Goldilocks wasn’t wearing a smile and her dress covered more than a teddy, though not much more. It was a scrap of crimson silk. He liked the way it clung to her breasts and hips. She had great hips, curved for the fit of a man’s hands…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was getting hard just watching her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sean downed the last of his bourbon, told himself to concentrate on cold showers and on solving the puzzle of why the blonde had been observing him with such caution.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was only a few feet away now. She hesitated. Then she lifted her chin, tossed back her hair, took a deep breath and smiled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He felt the wattage straight down to his toes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hi.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The tip of her tongue crept out, slicked across her bottom lip. Sean almost groaned but he managed a smile of his own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hi yourself,” he said. “I’d ask where you’ve been all my life, but you’d probably slug me for using such a trite line.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("She laughed. And blushed. Another nice touch. He ")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("couldn’t recall the last time he’d seen a woman blush, but her smile still glittered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Not at all. Actually, I was wondering how to tell you I was here alone, and that I’ve been alone for too long.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Her voice was soft. A liquid purr. It reminded him of honey and warm Southern nights. He moved closer.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Isn’t it fortunate that I finally got here?” he said softly. “What’s your name, sugar?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Savannah.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Ah.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Ah?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“The name suits you. You have moonlight and magnolias in that sexy drawl. You’re a Georgia girl.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Another rush of pink to her cheeks. Interesting, that she’d blush and still be so direct in coming on to him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Savannah what?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("She touched her tongue to her lips again. Did she know what that was doing to him? The tip of that pink tongue sweeping moistly across her rosebud mouth? He thought she did but when he looked into her eyes, he wasn’t so sure. They were a clear green, but there seemed to be a darkness hidden in their depths.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Just Savannah.” She closed the little distance that remained between them. He could smell her scent, a seductively innocent blend of vanilla and woman. “No last names tonight. Is that okay?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“It’s fine.” Sean cleared his throat. “I’m a sucker for a good mystery, Just-Savannah.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Just…?” Her eyebrows rose. Then she smiled. “I like that. ‘Just-Savannah.’”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Good. That gives us two things in common. Honesty and anonymity. That’s a fascinating combination, don’t you think?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Yes. I do. What shall I call you?”")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sean.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Something flickered in those incredible eyes. Relief? No. It couldn’t have been that. Why would a simple exchange of names inspire relief?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just-Sean,” she said, smiling.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just-Sean, and Just-Savannah. Two people without last names who meet and set out to discover what the rest of the night holds in store.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I like that.” She reached out and laid her hand lightly against his chest. “What game will you play tonight, Sean?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He felt his body clench like a fist. “It depends on who I’m playing it with,” he said hoarsely. “What did you have in mind?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She laughed. Her teeth were small, even, very white against the golden tan of her skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not sure.” Her eyes met his, then dropped away. “I’m new at this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was a great line, designed to set a man’s hormones pumping. All of it was designed for that: the face, the body, the scrap of red silk and the sexy, let’s-get-it-on banter…and yet, the only part of it he bought into was her being new at this. Somehow, that rang with truth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The lady wasn’t a pro.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Like moths to the proverbial flame, high-priced working girls were drawn to places where big money and big players congregated, but no matter how elegantly dressed and groomed they were, Sean could spot them at a hundred paces. Besides, a call girl would never get past the door of a private casino like L’Emeraude.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("No, Savannah wasn’t a pro. She had the looks and the lines, but her delivery was off. It was like listening to an actress who was still learning her part. And there were those ")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("moments he’d seen her hand tremble…as the one she’d put against his chest was doing now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("She was working at turning him on and she was succeeding, but she wasn’t lying. She was, he was sure, a novice at this game. As flattering as it was to think she’d turned into a lust-crazed creature at the sight of him, he didn’t buy it. There was the way she’d been watching him. Besides, he was too much of a realist to believe in bolts of lightning that struck with no warning.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Something else was going on here. He didn’t know what, but he was damned well going to find out.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Sean?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("He focused his gaze on the blonde’s upturned face. The smile was still there but the pretty flush in her cheeks was back. Was she flustered? Embarrassed? Or was it part of the act?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Sean. Have I been too…I mean, I’m sorry if—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Savannah.” He smiled and covered her hand with his. Her skin was icy. Instinctively, he closed his fingers around hers. “A beautiful woman should never apologize for anything.” Sean raised her hand to his mouth and pressed his lips to her knuckles. “Let’s make a pact.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“A pact?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“You won’t say you’re sorry again, and I’ll buy you a glass of champagne. Okay?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("She took a long time before she answered. Then, just when he’d decided she was going to turn him down, she nodded.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“That would be lovely.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Good.” Sean’s hand tightened on hers. “You have any thoughts on how to seal our agreement?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Another rush of color swept into her face. “What do you mean?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“It’s simple. We have a contract.” Sean lowered his ")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("voice to a husky whisper. “Now we need some way to guarantee it.” He looked at her slightly parted lips, then into her eyes. “You know. Sign in blood. Swear before witnesses. Cross your heart and hope to die.” He flashed a quick smile. “Something to make it official.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("He watched her face, saw the exact second she decided she’d had enough. Or maybe she’d decided to change tack. Try as he might, he couldn’t tell which.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“You’re making fun of me,” she said.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“No, I’m not.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“You are. You think this is funny, and you’re teasing me.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Teasing. Not making fun. There’s a world of difference.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Let go of my hand, please.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Why? I turn you on. You turn me on. That hasn’t changed. Why walk away from it before we’ve discovered what comes next?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("He didn’t know what he’d expected, though he’d gone out of his way to provoke a reaction. Would she blush some more? Lean into him and lift that luscious mouth to his? The combination of brashness and modesty was charming, even exciting, but it only made him more suspicious.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Whatever he might have anticipated, it wasn’t the way she suddenly stood straighter, or the way her chin lifted.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“You’re right,” she said. “Why walk away now?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Sean nodded. “That’s better.” It wasn’t. She sounded as if she’d decided to go to the dentist after all. What in hell was happening? Acting on impulse, he reached out, put his hand under her chin and tilted her face up. “As for that contract,” he said softly, “I know exactly how to seal the deal.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("All of her was trembling now, not just the hand pressed to his chest. For a woman who’d tried to convince him of ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("how eager she was to jump his bones, the lady was strangely nervous.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Sean smiled into her eyes, deliberately dropped his gaze to her mouth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“No,” she said quickly, the word a breathless whisper. “Please, don’t—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("He hadn’t intended to go through with it. The idea was to see how she’d react to the prospect of a kiss but when he saw her lips part, her eyes turn into the fresh green of a meadow after a spring rain, a shudder ran through his body. He wanted to kiss her. Kiss her, take her in his arms, carry her out of the noise and the light to a place where they’d be alone, where he could kiss her again and again until she trembled, yes, but trembled with need for him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Sean stepped back, his pulse hammering, every muscle in his body tight as steel.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Don’t toast a deal with a bottle of champagne?” he said with forced lightness. “Now, that’s definitely something no woman’s ever asked of me before.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Champ…” She caught her bottom lip between her teeth. He tried not to imagine it was his lip those perfect teeth were worrying. “Oh. I didn’t…I mean, that would be nice.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Besides, how could I let you go until I know why you stood in that alcove watching me for so long?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Her face whitened. “I was not watching you.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Telling fibs isn’t nice, sugar. Sure you were. And now you’re as nervous as a cat in a dog pound. Don’t get me wrong, sweetheart. I like getting beautiful women flustered—but I like to know the reason for it. Somehow, I don’t think your nerves have all that much to do with my masculine charms.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("She looked up at him, conflicting emotions warring in her eyes. For a heartbeat, Sean felt as if she were on the verge ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("of telling him something that would set him on a white charger like a knight ready to do battle with a dragon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("But she only smiled and angled her chin so she was gazing up at him through thick, honey-brown lashes.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“You’re right about my watching you,” she said softly, “but wrong in thinking it had nothing to do with your masculine charms.” She smiled again, just enough to give those words the light touch they deserved. “I hoped you wouldn’t notice.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“There’s not a man in the room wouldn’t notice you, if you were looking at him.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("She laughed. It was a flirty, delicious sound. “That’s very sweet.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“It’s the truth.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Her hand was on his chest again, her fingers toying lightly with the lapel of his jacket. Her lips were slightly parted; she tilted her head back and now he could see the swift beat of her pulse in the hollow of her throat.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Sean almost groaned. He’d played games like this before but he’d never felt as if every muscle in his body was on full alert until now.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“I think it’s time we got to know each other better, Just-Savannah.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“That sounds nice. What do you have in mind?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Taking her to bed. That was what he had in mind, but he wasn’t going to do that until he knew exactly what was going on here.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“The champagne I promised you, for starters.” He linked his fingers through hers. “And some privacy.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“I’d like that.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Warning bells rang in his head. The words were right. So was the come-and-get-me smile, but the look in her eyes was wrong.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Maybe it was time to up the ante.")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He turned her hand palm-up and lifted it to his mouth. He felt her stiffen as he pressed his lips to her flesh, felt her start to jerk her hand from his.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Easy, sugar. I haven’t taken a bite out of a woman in years. Not unless she wanted me to.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know. I just—I told you, this is all—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“—new. Yeah, so you said.” Sean’s smile was deliberately lazy. “Unless, of course, there’s more to the story than you’re letting on.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What more could there be, Mr. O’Connell? You’re a very attractive man. I’m sure I’m not the first woman to show an interest in you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The warning bells were going crazy. Mr. O’Connell? How could she know his name? He was Just-Sean. She was Just-Savannah. Definitely, there was more on her agenda. Should he call her on it? Should he play along?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked deep into the green eyes fixed to his. Hell. He was a gambler, wasn’t he? What did he have to lose?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Now, sugar,” he said softly, “what kind of gentleman would I be if I answered that question?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A slow, easy smile curved his mouth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Seeing it, Savannah almost sagged with relief. For one awful minute, she’d been afraid she’d given everything away. She’d come awfully close, saying the wrong things, letting her nerves show, but then she’d turned the situation around by using her mistakes to convince Sean O’Connell she’d never come on to a man before.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That, at least, was the truth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She couldn’t afford any more screw-ups.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d thought this would be easy, but it wasn’t. Using a deck of cards to scam a dumb mark on a dingy street corner was not the same as using your body, your smile, your words to scam an intelligent man in an elegant casino.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Besides, O’Connell was more than intelligent. He was ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("street-smart. She hadn’t expected that. He kept looking at her as if she were a candy bar he wanted to unwrap, but always with a wariness that made her uneasy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Not that it changed anything.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("She was in too far to stop. Either she went forward or she failed. And failure wasn’t an option.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("He was still smiling, but was there something in his eyes that shouldn’t be there? Time to come up with a clever move that would shut down his brain.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("A squeeze of her fingers in his might do it. A sexy smile. A flick of her tongue across her bottom lip. He’d reacted to that before.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Yes. It was working. His eyes were darkening, focusing on her mouth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“If you told me about those other women,” she said huskily, “you’d be the kind of man I’d run from. I don’t want you thinking about anyone but me tonight.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“There’s no way I could,” he said softly. Another light brush of his lips against her palm and then he tucked her hand into the crook of his arm. “Have you seen the terrace, Just-Savannah?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“No.” Her voice sounded thready. She cleared her throat. “No,” she repeated, and smiled up at him, almost weak with relief. Things were back on track. “No, I haven’t. I’ve never been here before.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Then you’re in for a treat.” He began walking slowly through the casino. Because of the way he’d captured her hand, she was pressed close to his side, aware of the warm length of his body, aware of the muscles in his thigh as it shifted against hers. “Let’s have a drink on the terrace and I’ll show you the most beautiful sight in these islands.” He glanced at her, angled his head down to hers and put his lips to her ear. “I take that back, sugar. The second most beautiful sight in these islands.”")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The warmth of his breath, the promise in his words sent a tingle of anticipation through her. For a moment, Savannah let herself imagine what it would be like if the story she’d spun were true. If she’d come here to gamble, noticed this tall, incredibly good-looking stranger, taken her courage in her hands and gone up to him with seduction, real seduction, in mind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But she hadn’t. She was here for a purpose.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Was O’Connell really as good a poker player as people claimed? Alain said he was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maybe. But she was better.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tonight, that was all that mattered.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d31eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/onenightwifethe_ch02.vue
// module id = 72
// module chunks = 0